import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
    return (
        <div data-testid="page-notfound" className="cap-section pt-32">
            <Seo title="Not found | Chief AI Partners" description="The page you are looking for could not be found." path="/404" />
            <div className="cap-container text-center max-w-2xl mx-auto">
                <div className="cap-eyebrow mb-4">Error 404</div>
                <h1 className="font-serif text-navy text-5xl md:text-6xl leading-tight">
                    We couldn't find that page.
                </h1>
                <p className="text-slate text-lg mt-5">
                    The link may be outdated or the page may have moved. Return to the homepage to continue.
                </p>
                <Link to="/" className="cap-btn-primary mt-8 inline-flex" data-testid="notfound-home-link">
                    Back to home
                </Link>
            </div>
        </div>
    );
}
